// Minimal WebMCP Tool Registration (feature-detect only)
if (typeof window !== 'undefined' && 'navigator' in window && 'modelContext' in navigator) {
  try {
    const tools = [
      {
        name: 'nodatx-open-docs',
        description: 'Open Nodatx API documentation',
        inputSchema: { type: 'object', properties: {} },
        execute: async () => {
          window.open('https://nodatx.com/docs/api', '_blank')
          return { ok: true }
        }
      }
    ]
    // Register a single example tool
    navigator.modelContext.registerTool({
      name: tools[0].name,
      description: tools[0].description,
      inputSchema: tools[0].inputSchema,
      execute: tools[0].execute,
      // AbortController to allow unregister if needed
      abortSignal: new AbortController().signal
    })
  } catch (e) {
    // Silently ignore if WebMCP is not supported or permissions blocked
  }
}
